import * as React from 'react'
import Header from '../../../brands/components/Header'
import SideNavbar from '../../../../components/SideNavbar'
import './index.css'
import ManagerNavbar from '../../../../components/SideNavbar/managerNav'
import { useAppSelector } from '../../../../redux/hook'
import EmpNavbar from '../../../../components/SideNavbar/EmpNav'

type LayoutProps = {
    children: React.ReactNode
}

const Layout = ({ children }: LayoutProps) => {
    const [toggle, setToggleNavbar] = React.useState(false)
    const getToggle = (value: boolean) => {
        setToggleNavbar(value)
    }

    const { role } = useAppSelector((state) => state.persistedReducers.user)

    return (
        <>
            <div>
                <div className={`container-fluid ${toggle ? 'collap' : ''}`}>
                    <div className="row">
                        {role === 'Admin' || role === 'Executive Director' ? (
                            <SideNavbar />
                        ) : role === 'Teacher' ? (
                            <EmpNavbar />
                        ) : (
                            <ManagerNavbar />
                        )}
                        <main
                            className="col-md-9 mt-3
                        ms-sm-auto
                         col-lg-10 
                         px-md-4 main-content-side1"
                        >
                            <Header toggle={getToggle} />
                            <div className="padd-top">{children}</div>
                        </main>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Layout
